// Mock analytics data for the dashboard

export const revenueData = [
	{ month: "Jul", revenue: 18600, expenses: 12400 },
	{ month: "Aug", revenue: 22100, expenses: 13800 },
	{ month: "Sep", revenue: 19800, expenses: 11200 },
	{ month: "Oct", revenue: 25400, expenses: 14600 },
	{ month: "Nov", revenue: 28900, expenses: 15200 },
	{ month: "Dec", revenue: 32100, expenses: 16800 },
	{ month: "Jan", revenue: 29700, expenses: 15400 },
	{ month: "Feb", revenue: 34500, expenses: 17200 },
];

export const trafficData = [
	{ day: "Mon", visitors: 2400, pageViews: 4800 },
	{ day: "Tue", visitors: 1398, pageViews: 3200 },
	{ day: "Wed", visitors: 3800, pageViews: 7100 },
	{ day: "Thu", visitors: 3908, pageViews: 6800 },
	{ day: "Fri", visitors: 4800, pageViews: 9200 },
	{ day: "Sat", visitors: 3800, pageViews: 6400 },
	{ day: "Sun", visitors: 2800, pageViews: 4900 },
];

export const categoryData = [
	{ name: "Direct", value: 35, fill: "var(--color-chart-1)" },
	{ name: "Organic", value: 28, fill: "var(--color-chart-2)" },
	{ name: "Referral", value: 18, fill: "var(--color-chart-3)" },
	{ name: "Social", value: 12, fill: "var(--color-chart-4)" },
	{ name: "Email", value: 7, fill: "var(--color-chart-5)" },
];

export const conversionData = [
	{ month: "Jul", rate: 2.1 },
	{ month: "Aug", rate: 2.4 },
	{ month: "Sep", rate: 2.8 },
	{ month: "Oct", rate: 3.1 },
	{ month: "Nov", rate: 3.5 },
	{ month: "Dec", rate: 3.2 },
	{ month: "Jan", rate: 3.8 },
	{ month: "Feb", rate: 4.2 },
];

export const topPages = [
	{ page: "/home", views: 12840, unique: 8920, bounce: "32%" },
	{ page: "/products", views: 8430, unique: 6210, bounce: "41%" },
	{ page: "/pricing", views: 6280, unique: 4890, bounce: "28%" },
	{ page: "/blog/react-tips", views: 4920, unique: 3640, bounce: "52%" },
	{ page: "/docs/getting-started", views: 3810, unique: 2980, bounce: "22%" },
];

export const recentActivity = [
	{
		user: "Sarah Chen",
		initials: "SC",
		action: "Completed purchase",
		amount: "$249.00",
		time: "2 min ago",
	},
	{
		user: "Marcus Johnson",
		initials: "MJ",
		action: "Signed up for Pro plan",
		amount: "$49.00/mo",
		time: "8 min ago",
	},
	{
		user: "Aisha Patel",
		initials: "AP",
		action: "Submitted support ticket",
		amount: "",
		time: "15 min ago",
	},
	{
		user: "David Kim",
		initials: "DK",
		action: "Upgraded to Enterprise",
		amount: "$199.00/mo",
		time: "32 min ago",
	},
	{
		user: "Elena Rodriguez",
		initials: "ER",
		action: "Downloaded report",
		amount: "",
		time: "1 hr ago",
	},
];
